import styled from 'styled-components';

import { colors } from '../../ui/variables';

export const LogoStyle = styled.svg`
  fill: ${colors.softBlue};

  &.default-theme {
    fill: ${colors.softBlue};
  }

  &.black-theme {
    fill: ${colors.black};
  }

  &.white-theme {
    fill: ${colors.white};
  }
`;
